export function getDaysToExpire(deadlineToApply) {
  if (!deadlineToApply) return null;

  const [year, month, day] = deadlineToApply.split('-').map(Number);

  const deadline = new Date(year, month - 1, day);
  const now = new Date();

  // deadline.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);

  return Math.ceil((deadline - now) / (1000 * 60 * 60 * 24));
}

export function getExpiryLabel(deadlineToApply) {
  const diffDays = getDaysToExpire(deadlineToApply);
  if (diffDays === null) return null;

  if (diffDays < 0) return null;

  const deadlineToApplyFormatted = String(deadlineToApply).replace(/-/g, '/');

  if (diffDays === 0) return { text: 'Expires today', color: '#BC8D00', date: deadlineToApplyFormatted };
  if (diffDays === 1) return { text: 'Expires in 1 day', color: '#BC8D00', date: deadlineToApplyFormatted };
  if (diffDays > 1 && diffDays <= 14) return { text: `Expires in ${diffDays} days`, color: '#BC8D00', date: deadlineToApplyFormatted };
}